<!--
 * @Descripttion: 高德地图
 * @version: 1.0.0
 * @@Company: ZZCYI
 * @Author: 刘
 * @Date: 2020-08-03 15:39:14
 * @LastEditors: 王
 * @LastEditTime: 2021-01-07 15:24:11
 * @Update Descripttion:
-->
<template>
  <div class="amap-wrapper">
    <!-- <el-amap-search-box
      class="search-box"
      v-model="searchQuery"
      :search-option="searchOption"
      :on-search-result="onSearchResult"
    /> -->
    <el-amap
      class="amap-box"
      :style="{ width: width, height: height }"
      :vid="'amap-vue-search'"
      ref="map"
      :center="center"
      :zoom="zoom"
      :events="events"
    >
      <el-amap-marker v-for="(marker, index) in markers" :position="marker" :key="index"></el-amap-marker>
    </el-amap>
  </div>
</template>

<script>
export default {
  name: 'MapG',
  props: {
    width: {
      type: String || Number,
      default: '100%',
    },
    height: {
      type: String || Number,
      default: '350px',
    },
  },
  data() {
    return {
      searchQuery: '',
      selected: {
        province: '', // 选择的省
        city: '', // 选择的市
        area: '', // 选择的区
      },
      zoom: 12,
      center: [116.396304, 39.909847],
      show: true,
      events: {
        click: (e) => {
          const that = this
          if (!e) {
            return
          }
          that.getRess(e.lnglat.lng, e.lnglat.lat)
        },
      },
      markers: [],
      nearbyPlaces: [],
      searchOption: {
        city: '',
        citylimit: false,
      },
    }
  },
  methods: {
    handleBack() {
      this.$emit('back')
    },
    changeLng(e) {
      this.center = e
      this.markers = [e]
    },
    searchNearby(data) {
      console.log(data, '顶顶顶顶对面')
      this.searchQuery = data
      this.selected.province = data.province.value
      this.selected.city = data.city.value
      this.selected.area = data.area.value
      this.searchOption.city = this.selected.city
      // 组合省市区作为搜索关键词
      this.searchQuery = `${this.selected.province}${this.selected.city}${this.selected.area}`
      this.geocodeAddress(this.searchQuery)
    },
    geocodeAddress(address) {
      console.log(address, 'addressaddressaddress')
      const geocoder = new AMap.Geocoder({
        city: this.selected.city, // 限制搜索城市
      })

      geocoder.getLocation(address, (status, result) => {
        console.log(status, result, 'result')
        if (status === 'complete' && result.info === 'OK') {
          const location = result.geocodes[0].location // 获取经纬度
          this.center = [location.lng, location.lat] // 更新地图中心点
          this.markers = [[location.lng, location.lat]] // 更新标记点位置
          console.log(this.markers, 'this.markersthis.markers')
        } else {
          console.error('地址解析失败:', result)
        }
      })
    },
    // 解析地址信息
    getRess(lng, lat) {
      var that = this
      const positionArr = []
      positionArr.push(lng)
      positionArr.push(lat)
      this.markers = []
      this.markers.push(positionArr)
      // 这里通过高德 SDK 完成。
      // eslint-disable-next-line no-undef
      var geocoder = new AMap.Geocoder({
        radius: 1000,
        extensions: 'all',
      })
      geocoder.getAddress(positionArr, function (status, result) {
        if (status === 'complete' && result.info === 'OK') {
          if (result && result.regeocode) {
            // let num = result.regeocode.formattedAddress
            // let indexs = result.regeocode.addressComponent.province.length
            // let index = num.indexOf('市') + 1
            // let city = num.substring(indexs, index)
            // if (city) {
            const detailObj = {
              addressComponent: result.regeocode.addressComponent,
              detailedAddress: result.regeocode.formattedAddress,
              city: result.regeocode.addressComponent.city,
              lng: positionArr[0],
              lat: positionArr[1],
            }
            console.log(detailObj, 'detailObjdetailObj')
            that.$emit('getInfo', detailObj)
            // }
          }
        }
      })
    },
    mapAddress(e) {
      const address = this.searchQuery + e
      console.log(address, '点点滴')
      this.geocodeAddress(address)
    },
    init(lng, lat, show) {
      console.log(lng, lat, show, 'showssss')
      // this.show = show
      if (lng && lat) {
        this.center = [lng, lat]
        this.markers = [this.center]

        this.$forceUpdate()
      } else {
        this.center = [lng, lat]
      }
      this.$forceUpdate()
    },
    onSearchResult(pois) {
      console.log(pois, 'poispoispois===')
      let latSum = 0
      let lngSum = 0
      if (pois.length > 0) {
        // this.searchQuery = pois[0].name
        pois.forEach((poi) => {
          const { lng, lat } = poi
          lngSum += lng
          latSum += lat
          this.markers.push([poi.lng, poi.lat])
        })
        const obj = pois[0]
        this.getRess(obj.lng, obj.lat)
        const center = {
          lng: lngSum / pois.length,
          lat: latSum / pois.length,
        }
        this.center = [center.lng, center.lat]
      }
    },
  },
}
</script>
<style scoped lang="less">
.amap-wrapper {
  text-align: right;
  position: relative;
}
.amap-box {
  width: 100%;
  height: 500px;
  /* margin-left: 5%; */
}
.search-box {
  position: absolute;
  top: 0px;
  /* left: 6%; */
  width: 100%;
}
// /deep/.el-vue-search-box-container .search-tips {
//   width: 100%;
//   background: #000;
//   color: #ffffff;
//   border: none;
// }
// /deep/.el-vue-search-box-container .search-tips ul li.autocomplete-selected {
//   background: #000;
// }
// /deep/.el-vue-search-box-container .search-tips ul li.autocomplete-selected {
//   background: #3e4752 !important;
//   color: #ffffff !important;
// }
// /deep/.el-vue-search-box-container .search-box-wrapper {
//   background: #3e4752 !important;
//   color: #ffffff !important;
//   input {
//     background: #3e4752 !important;
//     color: #ffffff !important;
//   }
// }
</style>
